module.exports = __webpack_public_path__ + "img/23.70d304f9.png";